// Generated by ReScript, PLEASE EDIT WITH CARE


function isTouchDevice(param) {
  var $$navigator = window.navigator;
  return $$navigator.maxTouchPoints > 0;
}

function isIOS(param) {
  return /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
}

export {
  isTouchDevice ,
  isIOS ,
}
/* No side effect */
